import { QueryClient } from 'react-query';

type Params = {
  query_client: QueryClient;
};

export const refetchStateVariables = ({ query_client }: Params) => {
  query_client.invalidateQueries('state_variables');
};
